import { p as patchApiToIncludeTotp } from "../_patches-94e7586e.mjs";
import { a as initI18n } from "../i18n-35335a5c.mjs";
import { u as uiHelpers } from "../_ui-71f9b37c.mjs";
import { i as i18n } from "../_i18n-e414d464.mjs";
import "../otpauth.esm-675c01d0.mjs";
import "../index-703c58ee.mjs";
import "../sudo-bad5b55e.mjs";
import "../index-38c53cf2.mjs";
import "vue";
import "../index-64135f7d.mjs";
import "../malarkeyTwilioAdapter-1c296255.mjs";
import "../index-13be80af.mjs";
import "../_commonjsHelpers-ca272635.mjs";
import "../_debug-8b5c3032.mjs";
import "joi";
import "../helpers-674591c1.mjs";
import "../event-socket/malarkeyEventSocketAdapter.es.js";
import "../index-fd2245c5.mjs";
const MalarkeySSRPlugin = {
  install(app, options) {
    if (app.config.globalProperties.$api) {
      if (!app.config.globalProperties.$http) {
        patchApiToIncludeTotp(app, options.psk);
      }
    }
    if ("object" !== typeof app.__VUE_I18N__) {
      app.use(i18n);
    }
    initI18n(app);
    if (!app.config.globalProperties.$alert) {
      app.use(uiHelpers);
    }
  }
};
export {
  MalarkeySSRPlugin
};
//# sourceMappingURL=ssr.es.js.map
